import {AttachmentTO} from 'generated/JavaTO';
import _ from 'lodash';
import {SisName} from 'util/SisName';

export type CFValue = null | undefined | string | number

export interface CFMember extends Omit<AttachmentTO, 'data'> {
	data?: CFValue
}

export type CFMemberData = Omit<CFMember, 'dstField'>

export function isCFMember(d: CFMember | CFValue): d is CFMember {
	return _.isPlainObject(d) && _.has(d, 'dstField') && _.has(d, 'pos')
}

export interface CFSetOptions {
	pos?: number
	userInput?: boolean
}

export interface CFGetOptions {
	pos?: number
	forView?: boolean
}

export type CFModel = CFModelFlat & { cf?: CFMember[], sisName?: SisName }
export type CFModelFlat = { [key in string]?: CFValue | any } // any for other attributes, that are not used by CF-Module (persNrs, stornos, etc.)

